import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import {
    mapData,
    capitalize,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { currencyFormat } from '@/custom/common/components'
import CartContext from '@/product/context/cart/cartContext'
import CartItem from './cartItem'
import './PaymentManage.css'
import Layout from '@/product/components/templates/Layout'
import { useHistory, withRouter } from 'react-router-dom'
import Loaders from '@/product/components/molecules/Loaders'
import StripeCardContext from '@/product/context/stripe/card/cardContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import { Button, Divider, ListItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CardDetails from '@/product/components/organisms/CardDetails/CardDetailsFromAdmin'
import StripeCustomerContext from '@/product/context/stripe/customer/customerContext'
import PayContext from '@/product/context/payment/payContext'
import AlertContext from '@/product/context/alert/alertContext'

let randomVariable = Math.random()

const CreditsManage = (props) => {
    const cartContext = useContext(CartContext)
    const [viewContent, setViewContent] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [paymentProcessing, setPaymentProcessing] = useState(false)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const {
        search_singlecart,
        getSingleCartProducts,
        payCartWallet,
        payCartOffline,
        responseStatus: payResponseStatus,
    } = cartContext

    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: responseStatusCard,
        clearResponse: clearResponseCard,
    } = useContext(StripeCardContext)

    // const {
    //     customer_details,
    //     createStripeCustomer,
    //     getStripeCustomer,
    //     responseStatus: customerResponseStatus,
    // } = useContext(StripeCustomerContext)

    const payContext = useContext(PayContext)
    const {
        payCartStripe,
        responseStatus: responseStatusPayment,
        clearResponse: clearResponsePayment,
    } = payContext

    const history = useHistory()
    const { t } = useTranslation()

    const isUrl =
        props?.match?.params?.id && props?.match?.params?.uid ? true : false

    const data = isUrl
        ? {
              ...props.data,
              id: props?.match?.params?.id,
              sid: props?.match?.params?.uid,
          }
        : props.data

    const toggleFullScreenPopup = props.function

    const handleClosePopup = () => {
        resetFrom()
        toggleFullScreenPopup(false)
    }

    const formik = useFormik({
        initialValues: {
            invoice_id: 0,
            user_id: 0,
        },
    })
    let [cartProducts, setCartProducts] = useState([])
    let [cartValues, setCartValues] = useState({})
    const [cards, setCards] = useState([])
    const [changeCard, setChangeCard] = useState(false)
    const [selectedCard, setSelectedCard] = useState(false)
    const [invoiceUser, setInvoiceUser] = useState({
        stripe_id: '',
        email: '',
        id: 0,
    })

    const [manageCard, setManageCard] = useState({
        popup: false,
        status: 'new',
        data: null,
        close: false,
        newCustomerId: '',
    })

    useEffect(() => {
        resetFrom()
        return () => {
            resetFrom()
        }
    }, [])

    useEffect(() => {
        resetFrom()
        if (data.status === 'edit' || data.status === 'view') {
            formik.values.invoice_id = data.id
            formikPayment.values.invoice_id = data.id
            formikPayment.values.user_id = data.sid
            formik.values.user_id = data.sid
            getSingleCartProducts(formik.values)
        }
    }, [data.id, manageCard.newCustomerId])

    useEffect(() => {
        if (payResponseStatus && payResponseStatus.status === 'success') {
            setPaymentProcessing(false)
            if (isUrl) {
                history.goBack()
                window.scrollTo(0, 0)
            }
        } else {
            setPaymentProcessing(false)
        }
    }, [payResponseStatus])

    const validationPayment = Yup.object({
        // appointmentID: Yup.string(),
        // pickupDay: Yup.string().when(['appointmentID'], {
        //     is: (a) => !a,
        //     then: Yup.string().required('Required'),
        // }),
        // pickupTime: Yup.string().when(['appointmentID'], {
        //     is: (a) => !a,
        //     then: Yup.string().required('Required'),
        // }),
        payment_method: Yup.string().required('Required'),
        card_type: Yup.string().when('payment_method', {
            is: 'offline',
            then: Yup.string().required('Required'),
        }),
        trans_id: Yup.string().when('payment_method', {
            is: 'offline',
            then: Yup.string().required('Required'),
        }),
        partial: Yup.boolean(),
        amount: Yup.number().when('partial', {
            is: true,
            then: Yup.number()
                .max(
                    cartValues ? cartValues.total_due_amount : 0,
                    `Max. Amount ${
                        cartValues
                            ? currencyFormat(cartValues.total_due_amount)
                            : currencyFormat(0)
                    }`
                )
                .min(
                    cartValues ? (cartValues.total_due_amount / 100) * 25 : 0,
                    `Min. Amount ${
                        cartValues
                            ? currencyFormat(
                                  (cartValues.total_due_amount / 100) * 25
                              )
                            : currencyFormat(0)
                    }`
                )
                .required('Enter Payment Amount'),
        }),
    })

    const formikPayment = useFormik({
        initialValues: {
            invoice_id: data.id,
            // appointmentID: '',
            appointmentTime: '',
            pickupDay: '',
            pickupTime: '',
            payment_method: 'offline',
            pay_type: 'auction',
            amount: 0,
            partial: false,
            user_id: 0,
            card_type: '',
            trans_id: '',
            address: '',
            delivery_mode: 0,
            cards: '',
        },
        validateOnBlur: false,
        validationSchema: validationPayment,
        onSubmit: (values) => {
            let appointmentTime = ''
            if (values.pickupDay && values.pickupTime) {
                let pickupChanged = values.pickupDay + ' ' + values.pickupTime
                appointmentTime = moment(
                    pickupChanged,
                    'MM-DD-YYYY HH:mm'
                ).format()
            }

            let formData = {
                invoice_id: values.invoice_id,
                payment_object: {
                    id: values.appointmentID,
                    appointmentTime: appointmentTime,
                    invoice_id: values.invoice_id,
                },
                payment_method: values.payment_method,
                pay_type: values.pay_type,
                amount: values.amount,
                user_id: values.user_id,
            }

            if (values.payment_method === 'offline') {
                ;(formData.paymentInstrument = values.card_type),
                    (formData.payment_method_type = values.payment_method)
                formData.custom_trans_id = values.trans_id
            }

            if (props?.full_payment) {
                formData.full_payment = true
            }

            if (values.payment_method === 'wallet') {
                payCartWallet(formData)

                setIsLoading(true)
                formikPayment.setSubmitting(true)
                setPaymentProcessing(true)
            } else if (values.payment_method === 'offline') {
                payCartOffline(formData)

                setIsLoading(true)
                formikPayment.setSubmitting(true)
                setPaymentProcessing(true)
            } else if (values.payment_method === 'card') {
                if (selectedCard.id) {
                    let formData = {
                        invoice_id: values.invoice_id,
                        user_id: values.user_id,
                        // cart_id: search.cart_id,
                        filters: {},
                        payment_object: {
                            id: values.appointmentID,
                            appointmentTime: appointmentTime
                                ? appointmentTime
                                : null,
                            invoice_id: values.invoice_id,
                        },
                        paymentInfo: {
                            source: selectedCard.id,
                            customer: invoiceUser.stripe_id || '',
                        },
                        payment_method: 'online',
                        payment_type:
                            values.payment_method !== 'bank'
                                ? 'card'
                                : values.payment_method,
                        pay_type: values.pay_type,
                        amount: values.amount,
                        additional_buynow_data: {
                            invoice_address_id:
                                formikPayment.values.address || '',
                        },
                        additional_buynow_update: true,
                        project: process.env.REACT_APP_SKYFLOW_PROJECT
                            ? process.env.REACT_APP_SKYFLOW_PROJECT
                            : 'skyflow',
                    }
                    payCartStripe(formData)

                    setIsLoading(true)
                    formikPayment.setSubmitting(true)
                    setPaymentProcessing(true)
                } else {
                    setAlert('Please select the payment card', 'error')
                }
            } else {
                setAlert('Please select the valid payment method!', 'error')
            }
        },
    })

    useEffect(() => {
        if (responseStatusPayment) {
            if (responseStatusPayment.from === 'payment') {
                setAlert(
                    responseStatusPayment.message,
                    responseStatusPayment.status
                )
                clearResponsePayment()
                if (
                    responseStatusPayment.status === 'success' ||
                    responseStatusPayment.status === 'COMPLETED'
                ) {
                    if (!isUrl) {
                        handleClosePopup()
                    }
                    handleRedirectInternal(history, 'invoice/paid')
                } else {
                    if (!isUrl) {
                        handleClosePopup()
                    }
                }
            }
        }
        return () => {
            clearResponsePayment()
        }
        //setLoading(false)
    }, [responseStatusPayment])

    const modeOfPayment = [
        {
            label: 'Select Mode of Payment',
            placeholder: 'Select Mode of Payment',
            type: 'select',
            class: `${
                formikPayment.values.payment_method === 'offline'
                    ? 'col-6'
                    : 'col-12'
            }`,
            options: props?.paymentMode?.length
                ? props.paymentMode
                : [
                      { value: 'offline', show: 'Offline' },
                      { value: 'wallet', show: 'Wallet' },
                      { value: 'card', show: 'Card' },
                  ],
            name: 'payment_method',
            formik: formikPayment,
        },
        {
            label: 'Payment Method',
            placeholder: 'Select Mode of Payment Method',
            type: 'select',
            class: `${
                formikPayment.values.payment_method === 'offline'
                    ? 'col-6'
                    : 'd-none'
            }`,
            options: [
                { value: 'Cash', show: 'Cash' },
                { value: 'Card', show: 'Card' },
            ],
            isNoDefaultOptionValue: true,
            name: 'card_type',
            formik: formikPayment,
        },
        {
            label: 'Trans ID / Ref / Notes',
            placeholder: 'Enter Trans ID / Ref / Notes',
            type: 'text',
            class: `${
                formikPayment.values.payment_method === 'offline'
                    ? 'col-12'
                    : 'd-none'
            }`,
            name: 'trans_id',
            formik: formikPayment,
        },
    ]
    // if (false && formikPayment.values.payment_method !== 'offline') {
    //     modeOfPayment.push(
    //         {
    //             label: t('make_a_partial_payment'),
    //             placeholder: t('make_a_partial_payment'),
    //             type: 'switch',
    //             class: 'col-12',
    //             name: 'partial',
    //             formik: formikPayment,
    //         },
    //         {
    //             label: t('enter_amount'),
    //             name: 'amount',
    //             type: 'number',
    //             placeholder: t('enter_payment_amount'),
    //             class: `col-12 ${formikPayment.values.partial ? '' : 'd-none'}`,
    //             formik: formikPayment,
    //         },
    //     )
    // }

    const toggleFullScreenCardPopup = (
        popup,
        status,
        data,
        close,
        newCustomerId
    ) => {
        setManageCard({ popup, status, data, close, newCustomerId })
    }

    useEffect(() => {
        if (
            get_all_card_details?.from === randomVariable &&
            // `${randomVariable}_${invoiceUser.id}` &&
            get_all_card_details.records?.length
        ) {
            setCards(get_all_card_details.records)
            if (
                !formikPayment.values.cards &&
                formikPayment.values.payment_method === 'card'
            ) {
                handleSelect(get_all_card_details.records[0])
                // formikPayment.setFieldValue('payment_method', 'card')
            }
            clearResponseCard()
        } else {
            setSelectedCard(false)
            setCards([])
            clearResponseCard()
        }
        return () => {
            setSelectedCard(false)
            setCards([])
            clearResponseCard()
        }
    }, [get_all_card_details, formikPayment.values.payment_method])

    useEffect(() => {
        setCartProducts(
            search_singlecart.cartrecords.length
                ? search_singlecart.cartrecords
                : []
        )
        setCartValues(search_singlecart.cartvalues)
        // formikPayment.values.appointmentID = search_singlecart.cartrecords
        //     .length
        //     ? search_singlecart.cartrecords[0].appointment_id
        //     : ''
        formikPayment.values.user_id = search_singlecart.cartrecords.length
            ? search_singlecart.cartrecords[0].user_id
            : []

        formikPayment.values.amount = search_singlecart.cartvalues
            ? search_singlecart.cartvalues.total_due_amount
            : []
        setIsLoading(false)
    }, [search_singlecart])

    useEffect(() => {
        // check stripe customer id
        if (cartProducts.length && cartProducts[0]?.users_id) {
            if (cartProducts[0]?.custom_users_stripe_id) {
                setSelectedCard(false)
                setCards([])
                randomVariable = Math.random()
                getAllStripeCards(
                    {
                        account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                        customer_id:
                            cartProducts[0]?.custom_users_stripe_id || '',
                        object: 'card',
                    },
                    randomVariable
                    // `${randomVariable}_${cartProducts[0]?.users_id}`
                )

                toggleFullScreenCardPopup(false, 'new', null)
            }
            setInvoiceUser({
                id: cartProducts[0]?.users_id,
                stripe_id: cartProducts[0]?.custom_users_stripe_id || '',
                email: cartProducts[0]?.users_email,
            })
        } else {
            setInvoiceUser({
                id: 0,
                stripe_id: '',
                email: '',
            })
        }
    }, [cartProducts, manageCard.close])

    useEffect(() => {
        return () => {
            setIsLoading(true)
        }
    }, [])

    const handleSelect = (object) => {
        setSelectedCard(object)
        formikPayment.setFieldValue('payment_method', 'card')
        formikPayment.setFieldValue('cards', object.id)
        setChangeCard(false)
    }

    const resetFrom = () => {
        setIsLoading(true)
        setCartProducts([])
        setCartValues({})
        setCards([])
        setManageCard({
            popup: false,
            status: 'new',
            data: null,
            close: false,
        })
        setInvoiceUser({ stripe_id: '', email: '', id: 0 })
        setSelectedCard(false)
        setChangeCard(false)
        setViewContent(null)
        formik.setFieldValue(formik.initialValues)
        formikPayment.setFieldValue(formikPayment.initialValues)
        formik.setTouched({}, false)
        formikPayment.setTouched({}, false)
        formik.resetForm()
        formikPayment.resetForm()
        setPaymentProcessing(false)
    }

    return isUrl ? (
        <Layout>
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <>
                    <form
                        onSubmit={formikPayment.handleSubmit}
                        autoComplete="nofill"
                    >
                        <div className="checkout container-lg">
                            <div className="checkoutCnt d-flex justify-content-between">
                                <div className="checkoutLt">
                                    <div className="review">
                                        <div className="d-flex align-items-center mb-3">
                                            <h1 className="checkoutHead m-0">
                                                Review order
                                            </h1>
                                            <span>
                                                {cartProducts.length} items
                                            </span>
                                        </div>
                                        {cartProducts.length ? (
                                            <div className="cartProducts">
                                                <div>
                                                    {cartProducts.map(
                                                        (data, index) => (
                                                            <CartItem
                                                                key={index}
                                                                data={data}
                                                                from={
                                                                    props?.from
                                                                        ? props.from
                                                                        : 'checkout'
                                                                }
                                                            />
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>

                                <div className="checkoutRt">
                                    <div className="orderSummary">
                                        <div>
                                            <h3>Order Summary</h3>
                                            <p>
                                                <label>Items:</label>
                                                <span>
                                                    {cartProducts.length}
                                                </span>
                                            </p>
                                            <p>
                                                <label>Sub Total:</label>
                                                <span>
                                                    {currencyFormat(
                                                        cartValues.per_total
                                                    )}
                                                </span>
                                            </p>
                                            <p>
                                                <label>
                                                    {props.taxLabel
                                                        ? props.taxLabel
                                                        : 'VAT:'}{' '}
                                                </label>
                                                <span>
                                                    {currencyFormat(
                                                        cartValues.total_tax
                                                    )}
                                                </span>
                                            </p>
                                            <p>
                                                <label>Total Amount:</label>
                                                <span>
                                                    {currencyFormat(
                                                        cartValues.total_amount
                                                    )}
                                                </span>
                                            </p>
                                            {/* <Tooltip title="You can choose to make a partial payment of 25% and above of your total amount now and pay the remaining amount later."></Tooltip> */}
                                            {cartValues.total_deposit ? (
                                                <p>
                                                    <label>
                                                        Total Deposit:
                                                    </label>
                                                    <span>
                                                        {currencyFormat(
                                                            cartValues.total_deposit
                                                        )}
                                                    </span>
                                                </p>
                                            ) : null}
                                            {cartValues.total_paid ? (
                                                <p>
                                                    <label>Total paid:</label>
                                                    <span>
                                                        {currencyFormat(
                                                            cartValues.total_paid
                                                        )}
                                                    </span>
                                                </p>
                                            ) : null}
                                            {cartValues.total_due_amount ? (
                                                <p>
                                                    <label>Due Amount:</label>
                                                    <span>
                                                        {currencyFormat(
                                                            cartValues.total_due_amount
                                                        )}
                                                    </span>
                                                </p>
                                            ) : null}
                                            <div className="row">
                                                {mapData(modeOfPayment)}
                                            </div>
                                            <div className="billingInfo">
                                                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
                                                    {!changeCard && (
                                                        <>
                                                            {/* <h1 className="checkoutHead m-0 mt-2">
                                                            PAYMENT METHOD
                                                        </h1> */}
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'card' && (
                                                                <h4 className="checkoutHead m-0 mt-2">
                                                                    Card Details
                                                                </h4>
                                                            )}
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'bank' && (
                                                                <h4 className="checkoutHead m-0 mt-2">
                                                                    Bank Details
                                                                </h4>
                                                            )}
                                                            {formikPayment
                                                                .values
                                                                .payment_method !==
                                                                '' &&
                                                                (formikPayment
                                                                    .values
                                                                    .payment_method ===
                                                                    'card' ||
                                                                    formikPayment
                                                                        .values
                                                                        .payment_method ===
                                                                        'bank') && (
                                                                    <Button
                                                                        id="checkoutPage_show"
                                                                        onClick={() =>
                                                                            setChangeCard(
                                                                                !changeCard
                                                                            )
                                                                        }
                                                                    >
                                                                        Show
                                                                    </Button>
                                                                )}
                                                        </>
                                                    )}
                                                </div>
                                                {changeCard && (
                                                    <>
                                                        {formikPayment.values
                                                            .payment_method ===
                                                            'card' && (
                                                            <>
                                                                <div className="chCnt d-flex justify-content-start align-items-center flex-wrap">
                                                                    {cards &&
                                                                    cards.length
                                                                        ? cards.map(
                                                                              (
                                                                                  data,
                                                                                  index
                                                                              ) => (
                                                                                  // eslint-disable-next-line react/jsx-key
                                                                                  <div className="checkoutSavedCard w-100  d-flex justify-content-start align-items-center">
                                                                                      <input
                                                                                          name="cards"
                                                                                          value={
                                                                                              data.id
                                                                                          }
                                                                                          onChange={() => {
                                                                                              setChangeCard(
                                                                                                  false
                                                                                              )
                                                                                              handleSelect(
                                                                                                  data
                                                                                              )
                                                                                          }}
                                                                                          type="radio"
                                                                                          id={`card_${index}`}
                                                                                          hidden
                                                                                      ></input>
                                                                                      <label
                                                                                          htmlFor={`card_${index}`}
                                                                                          className="w-100 m-0"
                                                                                      >
                                                                                          <ListItem
                                                                                              className="CardList"
                                                                                              button
                                                                                          >
                                                                                              {data.id ===
                                                                                              formikPayment
                                                                                                  .values
                                                                                                  .cards ? (
                                                                                                  <span className="material-icons">
                                                                                                      radio_button_checked
                                                                                                  </span>
                                                                                              ) : (
                                                                                                  <span className="material-icons">
                                                                                                      radio_button_unchecked
                                                                                                  </span>
                                                                                              )}

                                                                                              <div
                                                                                                  className="billingSavedCard "
                                                                                                  key={
                                                                                                      index
                                                                                                  }
                                                                                              >
                                                                                                  <div className="cardDetails">
                                                                                                      <h6>
                                                                                                          {
                                                                                                              data.name
                                                                                                          }
                                                                                                      </h6>
                                                                                                      <h6>
                                                                                                          {
                                                                                                              data.brand
                                                                                                          }{' '}
                                                                                                          ending
                                                                                                          in{' '}
                                                                                                          {
                                                                                                              data.last4
                                                                                                          }
                                                                                                      </h6>
                                                                                                      <h6>
                                                                                                          EXP:{' '}
                                                                                                          {
                                                                                                              data.exp_month
                                                                                                          }

                                                                                                          /
                                                                                                          {
                                                                                                              data.exp_year
                                                                                                          }
                                                                                                      </h6>
                                                                                                  </div>
                                                                                                  <div className="actionBtn">
                                                                                                      <Button
                                                                                                          id="checkoutPage_update"
                                                                                                          onClick={() =>
                                                                                                              toggleFullScreenCardPopup(
                                                                                                                  true,
                                                                                                                  'update',
                                                                                                                  data
                                                                                                              )
                                                                                                          }
                                                                                                      >
                                                                                                          Edit
                                                                                                      </Button>
                                                                                                      <Button
                                                                                                          id="checkoutPage_delete"
                                                                                                          onClick={() =>
                                                                                                              toggleFullScreenCardPopup(
                                                                                                                  false,
                                                                                                                  'delete',
                                                                                                                  data
                                                                                                              )
                                                                                                          }
                                                                                                      >
                                                                                                          Delete
                                                                                                      </Button>
                                                                                                  </div>
                                                                                              </div>
                                                                                          </ListItem>
                                                                                      </label>
                                                                                  </div>
                                                                              )
                                                                          )
                                                                        : null}
                                                                </div>
                                                            </>
                                                        )}
                                                        <>
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'bank' && (
                                                                <div className="">
                                                                    {banks &&
                                                                    banks.length
                                                                        ? banks.map(
                                                                              (
                                                                                  data,
                                                                                  index
                                                                              ) => (
                                                                                  // eslint-disable-next-line react/jsx-key
                                                                                  <div className="selectAddress  d-flex justify-content-start align-items-center">
                                                                                      <input
                                                                                          name="cards"
                                                                                          value={
                                                                                              data.id
                                                                                          }
                                                                                          onChange={() => {
                                                                                              setChangeCard(
                                                                                                  false
                                                                                              )
                                                                                              handleSelect(
                                                                                                  data
                                                                                              )
                                                                                          }}
                                                                                          type="radio"
                                                                                          id={`bank_${index}`}
                                                                                          hidden
                                                                                      ></input>
                                                                                      <label
                                                                                          className="w-100"
                                                                                          htmlFor={`bank_${index}`}
                                                                                      >
                                                                                          <ListItem
                                                                                              button
                                                                                              className="CardList"
                                                                                          >
                                                                                              {data.id ===
                                                                                              formikPayment
                                                                                                  .values
                                                                                                  .cards ? (
                                                                                                  <span className="material-icons">
                                                                                                      radio_button_checked
                                                                                                  </span>
                                                                                              ) : (
                                                                                                  <span className="material-icons">
                                                                                                      radio_button_unchecked
                                                                                                  </span>
                                                                                              )}
                                                                                              <div
                                                                                                  className="savedAddressCard bank"
                                                                                                  key={
                                                                                                      index
                                                                                                  }
                                                                                              >
                                                                                                  <div className="cardDetails">
                                                                                                      <h6>
                                                                                                          {
                                                                                                              data.bank_name
                                                                                                          }
                                                                                                      </h6>
                                                                                                      <h6>
                                                                                                          {
                                                                                                              data.last4
                                                                                                          }

                                                                                                          /
                                                                                                          {
                                                                                                              data.routing_number
                                                                                                          }
                                                                                                      </h6>
                                                                                                  </div>
                                                                                                  {data.status ===
                                                                                                  'new' ? (
                                                                                                      <Button
                                                                                                          id="checkoutPage_verify"
                                                                                                          onClick={() => {
                                                                                                              toggleFullScreenBankPopup(
                                                                                                                  true,
                                                                                                                  'verify',
                                                                                                                  data
                                                                                                              )
                                                                                                          }}
                                                                                                      >
                                                                                                          {' '}
                                                                                                          Verify
                                                                                                      </Button>
                                                                                                  ) : null}
                                                                                                  <Button
                                                                                                      id="checkoutPage_update"
                                                                                                      onClick={() =>
                                                                                                          toggleFullScreenBankPopup(
                                                                                                              true,
                                                                                                              'update',
                                                                                                              data
                                                                                                          )
                                                                                                      }
                                                                                                  >
                                                                                                      Edit
                                                                                                  </Button>
                                                                                                  <Button
                                                                                                      id="checkoutPage_deleteData"
                                                                                                      onClick={() =>
                                                                                                          toggleFullScreenBankPopup(
                                                                                                              true,
                                                                                                              'delete',
                                                                                                              data
                                                                                                          )
                                                                                                      }
                                                                                                  >
                                                                                                      Delete
                                                                                                  </Button>
                                                                                              </div>
                                                                                          </ListItem>
                                                                                      </label>
                                                                                  </div>
                                                                              )
                                                                          )
                                                                        : null}
                                                                </div>
                                                            )}
                                                        </>
                                                        <Divider />

                                                        <>
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'card' && (
                                                                <Button
                                                                    id="checkoutPage_add_card"
                                                                    onClick={() => {
                                                                        toggleFullScreenCardPopup(
                                                                            true,
                                                                            'new',
                                                                            null
                                                                        )
                                                                    }}
                                                                    className="checkoutAddBtn "
                                                                >
                                                                    <span className="material-icons">
                                                                        add
                                                                    </span>
                                                                    Add New Card
                                                                </Button>
                                                            )}
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'bank' && (
                                                                <Button
                                                                    id="checkoutPage_add_bank"
                                                                    onClick={() => {
                                                                        toggleFullScreenBankPopup(
                                                                            true,
                                                                            'new',
                                                                            null
                                                                        )
                                                                    }}
                                                                    className="checkoutAddBtn"
                                                                >
                                                                    <span className="material-icons">
                                                                        add
                                                                    </span>
                                                                    Add New Bank
                                                                </Button>
                                                            )}
                                                        </>
                                                    </>
                                                )}
                                                {!changeCard &&
                                                    selectedCard && (
                                                        <>
                                                            {selectedCard.object ===
                                                            'bank_account' ? (
                                                                <>
                                                                    <ListItem
                                                                        button
                                                                        className="CardList"
                                                                    >
                                                                        <div className="savedAddressCard">
                                                                            <div className="cardDetails">
                                                                                <h6>
                                                                                    {
                                                                                        selectedCard.bank_name
                                                                                    }
                                                                                </h6>
                                                                                <h6>
                                                                                    {
                                                                                        selectedCard.last4
                                                                                    }

                                                                                    /
                                                                                    {
                                                                                        selectedCard.routing_number
                                                                                    }
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    </ListItem>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <ListItem
                                                                        button
                                                                        className="CardList"
                                                                    >
                                                                        <div className="savedAddressCard">
                                                                            <div className="cardDetails">
                                                                                <h6>
                                                                                    {
                                                                                        selectedCard.name
                                                                                    }
                                                                                </h6>
                                                                                <h6>
                                                                                    {
                                                                                        selectedCard.brand
                                                                                    }{' '}
                                                                                    ending
                                                                                    in{' '}
                                                                                    {
                                                                                        selectedCard.last4
                                                                                    }
                                                                                </h6>
                                                                                <h6>
                                                                                    EXP:{' '}
                                                                                    {
                                                                                        selectedCard.exp_month
                                                                                    }

                                                                                    /
                                                                                    {
                                                                                        selectedCard.exp_year
                                                                                    }
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    </ListItem>
                                                                    {/* <div className="row">
                                                                    {mapData(cvvForm)}
                                                                </div> */}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                            </div>
                                            {isLoading && <div>Loading...</div>}
                                            <PrimaryButton
                                                disabled={paymentProcessing}
                                                id="credit_submit"
                                                type="submit"
                                                label={'Make Payment'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="PaymentModal">
                        <CardDetails
                            data={manageCard}
                            user={invoiceUser}
                            function={toggleFullScreenCardPopup}
                        />
                    </div>
                </>
            )}
        </Layout>
    ) : (
        <FullScreenPopup
            modaltitle={`Manage Payment`}
            open={data.popup}
            handleClose={() => handleClosePopup()}
        >
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <>
                    <form
                        onSubmit={formikPayment.handleSubmit}
                        autoComplete="nofill"
                    >
                        <div className="checkout container-lg">
                            <div className="checkoutCnt d-flex justify-content-between">
                                <div className="checkoutLt">
                                    <div className="review">
                                        <div className="d-flex align-items-center mb-3">
                                            <h1 className="checkoutHead m-0">
                                                Review order
                                            </h1>
                                            <span>
                                                {cartProducts.length} items
                                            </span>
                                        </div>
                                        {cartProducts.length ? (
                                            <div className="cartProducts">
                                                <div>
                                                    {cartProducts.map(
                                                        (data, index) => (
                                                            <CartItem
                                                                key={index}
                                                                data={data}
                                                                from={
                                                                    props?.from
                                                                        ? props.from
                                                                        : 'checkout'
                                                                }
                                                                taxLabel={
                                                                    props.taxLabel
                                                                }
                                                            />
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>

                                <div className="checkoutRt">
                                    <div className="orderSummary">
                                        <div>
                                            <h3>Order Summary</h3>
                                            <p>
                                                <label>Items:</label>
                                                <span>
                                                    {cartProducts.length}
                                                </span>
                                            </p>
                                            <p>
                                                <label>Sub Total:</label>
                                                <span>
                                                    {currencyFormat(
                                                        cartValues.per_total
                                                    )}
                                                </span>
                                            </p>
                                            <p>
                                                <label>
                                                    {props.taxLabel
                                                        ? `${props.taxLabel} :`
                                                        : 'VAT:'}{' '}
                                                </label>
                                                <span>
                                                    {currencyFormat(
                                                        cartValues.total_tax
                                                    )}
                                                </span>
                                            </p>
                                            {cartValues?.total_premium ? (
                                                <p>
                                                    <label>
                                                        Buyer Premium:
                                                    </label>
                                                    <span>
                                                        {currencyFormat(
                                                            cartValues.total_premium
                                                        )}
                                                    </span>
                                                </p>
                                            ) : null}
                                            <p>
                                                <label>Total Amount:</label>
                                                <span>
                                                    {currencyFormat(
                                                        cartValues.total_amount
                                                    )}
                                                </span>
                                            </p>
                                            {/* <Tooltip title="You can choose to make a partial payment of 25% and above of your total amount now and pay the remaining amount later."></Tooltip> */}
                                            {cartValues.total_deposit ? (
                                                <p>
                                                    <label>
                                                        Total Deposit:
                                                    </label>
                                                    <span>
                                                        {currencyFormat(
                                                            cartValues.total_deposit
                                                        )}
                                                    </span>
                                                </p>
                                            ) : null}
                                            {cartValues.total_paid ? (
                                                <p>
                                                    <label>Total paid:</label>
                                                    <span>
                                                        {currencyFormat(
                                                            cartValues.total_paid
                                                        )}
                                                    </span>
                                                </p>
                                            ) : null}
                                            {cartValues.total_due_amount ? (
                                                <p>
                                                    <label>Due Amount:</label>
                                                    <span>
                                                        {currencyFormat(
                                                            cartValues.total_due_amount
                                                        )}
                                                    </span>
                                                </p>
                                            ) : null}
                                            <div className="row">
                                                {mapData(modeOfPayment)}
                                            </div>
                                            <div className="billingInfo">
                                                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
                                                    {!changeCard && (
                                                        <>
                                                            {/* <h1 className="checkoutHead m-0 mt-2">
                                                            PAYMENT METHOD
                                                        </h1> */}
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'card' && (
                                                                <h4 className="checkoutHead m-0 mt-2">
                                                                    Card Details
                                                                </h4>
                                                            )}
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'bank' && (
                                                                <h4 className="checkoutHead m-0 mt-2">
                                                                    Bank Details
                                                                </h4>
                                                            )}
                                                            {formikPayment
                                                                .values
                                                                .payment_method !==
                                                                '' &&
                                                                (formikPayment
                                                                    .values
                                                                    .payment_method ===
                                                                    'card' ||
                                                                    formikPayment
                                                                        .values
                                                                        .payment_method ===
                                                                        'bank') && (
                                                                    <Button
                                                                        id="checkoutPage_show"
                                                                        onClick={() =>
                                                                            setChangeCard(
                                                                                !changeCard
                                                                            )
                                                                        }
                                                                    >
                                                                        Show
                                                                    </Button>
                                                                )}
                                                        </>
                                                    )}
                                                </div>
                                                {changeCard && (
                                                    <>
                                                        {formikPayment.values
                                                            .payment_method ===
                                                            'card' && (
                                                            <>
                                                                <div className="chCnt d-flex justify-content-start align-items-center flex-wrap">
                                                                    {cards &&
                                                                    cards.length
                                                                        ? cards.map(
                                                                              (
                                                                                  data,
                                                                                  index
                                                                              ) => (
                                                                                  // eslint-disable-next-line react/jsx-key
                                                                                  <div className="checkoutSavedCard w-100  d-flex justify-content-start align-items-center">
                                                                                      <input
                                                                                          name="cards"
                                                                                          value={
                                                                                              data.id
                                                                                          }
                                                                                          onChange={() => {
                                                                                              setChangeCard(
                                                                                                  false
                                                                                              )
                                                                                              handleSelect(
                                                                                                  data
                                                                                              )
                                                                                          }}
                                                                                          type="radio"
                                                                                          id={`card_${index}`}
                                                                                          hidden
                                                                                      ></input>
                                                                                      <label
                                                                                          htmlFor={`card_${index}`}
                                                                                          className="w-100 m-0"
                                                                                      >
                                                                                          <ListItem
                                                                                              className="CardList"
                                                                                              button
                                                                                          >
                                                                                              {data.id ===
                                                                                              formikPayment
                                                                                                  .values
                                                                                                  .cards ? (
                                                                                                  <span className="material-icons">
                                                                                                      radio_button_checked
                                                                                                  </span>
                                                                                              ) : (
                                                                                                  <span className="material-icons">
                                                                                                      radio_button_unchecked
                                                                                                  </span>
                                                                                              )}

                                                                                              <div
                                                                                                  className="billingSavedCard "
                                                                                                  key={
                                                                                                      index
                                                                                                  }
                                                                                              >
                                                                                                  <div className="cardDetails">
                                                                                                      <h6>
                                                                                                          {
                                                                                                              data.name
                                                                                                          }
                                                                                                      </h6>
                                                                                                      <h6>
                                                                                                          {
                                                                                                              data.brand
                                                                                                          }{' '}
                                                                                                          ending
                                                                                                          in{' '}
                                                                                                          {
                                                                                                              data.last4
                                                                                                          }
                                                                                                      </h6>
                                                                                                      <h6>
                                                                                                          EXP:{' '}
                                                                                                          {
                                                                                                              data.exp_month
                                                                                                          }

                                                                                                          /
                                                                                                          {
                                                                                                              data.exp_year
                                                                                                          }
                                                                                                      </h6>
                                                                                                  </div>
                                                                                                  <div className="actionBtn">
                                                                                                      <Button
                                                                                                          id="checkoutPage_update"
                                                                                                          onClick={() =>
                                                                                                              toggleFullScreenCardPopup(
                                                                                                                  true,
                                                                                                                  'update',
                                                                                                                  data
                                                                                                              )
                                                                                                          }
                                                                                                      >
                                                                                                          Edit
                                                                                                      </Button>
                                                                                                      <Button
                                                                                                          id="checkoutPage_delete"
                                                                                                          onClick={() =>
                                                                                                              toggleFullScreenCardPopup(
                                                                                                                  false,
                                                                                                                  'delete',
                                                                                                                  data
                                                                                                              )
                                                                                                          }
                                                                                                      >
                                                                                                          Delete
                                                                                                      </Button>
                                                                                                  </div>
                                                                                              </div>
                                                                                          </ListItem>
                                                                                      </label>
                                                                                  </div>
                                                                              )
                                                                          )
                                                                        : null}
                                                                </div>
                                                            </>
                                                        )}
                                                        <>
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'bank' && (
                                                                <div className="">
                                                                    {banks &&
                                                                    banks.length
                                                                        ? banks.map(
                                                                              (
                                                                                  data,
                                                                                  index
                                                                              ) => (
                                                                                  // eslint-disable-next-line react/jsx-key
                                                                                  <div className="selectAddress  d-flex justify-content-start align-items-center">
                                                                                      <input
                                                                                          name="cards"
                                                                                          value={
                                                                                              data.id
                                                                                          }
                                                                                          onChange={() => {
                                                                                              setChangeCard(
                                                                                                  false
                                                                                              )
                                                                                              handleSelect(
                                                                                                  data
                                                                                              )
                                                                                          }}
                                                                                          type="radio"
                                                                                          id={`bank_${index}`}
                                                                                          hidden
                                                                                      ></input>
                                                                                      <label
                                                                                          className="w-100"
                                                                                          htmlFor={`bank_${index}`}
                                                                                      >
                                                                                          <ListItem
                                                                                              button
                                                                                              className="CardList"
                                                                                          >
                                                                                              {data.id ===
                                                                                              formikPayment
                                                                                                  .values
                                                                                                  .cards ? (
                                                                                                  <span className="material-icons">
                                                                                                      radio_button_checked
                                                                                                  </span>
                                                                                              ) : (
                                                                                                  <span className="material-icons">
                                                                                                      radio_button_unchecked
                                                                                                  </span>
                                                                                              )}
                                                                                              <div
                                                                                                  className="savedAddressCard bank"
                                                                                                  key={
                                                                                                      index
                                                                                                  }
                                                                                              >
                                                                                                  <div className="cardDetails">
                                                                                                      <h6>
                                                                                                          {
                                                                                                              data.bank_name
                                                                                                          }
                                                                                                      </h6>
                                                                                                      <h6>
                                                                                                          {
                                                                                                              data.last4
                                                                                                          }

                                                                                                          /
                                                                                                          {
                                                                                                              data.routing_number
                                                                                                          }
                                                                                                      </h6>
                                                                                                  </div>
                                                                                                  {data.status ===
                                                                                                  'new' ? (
                                                                                                      <Button
                                                                                                          id="checkoutPage_verify"
                                                                                                          onClick={() => {
                                                                                                              toggleFullScreenBankPopup(
                                                                                                                  true,
                                                                                                                  'verify',
                                                                                                                  data
                                                                                                              )
                                                                                                          }}
                                                                                                      >
                                                                                                          {' '}
                                                                                                          Verify
                                                                                                      </Button>
                                                                                                  ) : null}
                                                                                                  <Button
                                                                                                      id="checkoutPage_update"
                                                                                                      onClick={() =>
                                                                                                          toggleFullScreenBankPopup(
                                                                                                              true,
                                                                                                              'update',
                                                                                                              data
                                                                                                          )
                                                                                                      }
                                                                                                  >
                                                                                                      Edit
                                                                                                  </Button>
                                                                                                  <Button
                                                                                                      id="checkoutPage_deleteData"
                                                                                                      onClick={() =>
                                                                                                          toggleFullScreenBankPopup(
                                                                                                              true,
                                                                                                              'delete',
                                                                                                              data
                                                                                                          )
                                                                                                      }
                                                                                                  >
                                                                                                      Delete
                                                                                                  </Button>
                                                                                              </div>
                                                                                          </ListItem>
                                                                                      </label>
                                                                                  </div>
                                                                              )
                                                                          )
                                                                        : null}
                                                                </div>
                                                            )}
                                                        </>
                                                        <Divider />

                                                        <>
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'card' && (
                                                                <Button
                                                                    id="checkoutPage_add_card"
                                                                    onClick={() => {
                                                                        toggleFullScreenCardPopup(
                                                                            true,
                                                                            'new',
                                                                            null
                                                                        )
                                                                    }}
                                                                    className="checkoutAddBtn "
                                                                >
                                                                    <span className="material-icons">
                                                                        add
                                                                    </span>
                                                                    Add New Card
                                                                </Button>
                                                            )}
                                                            {formikPayment
                                                                .values
                                                                .payment_method ===
                                                                'bank' && (
                                                                <Button
                                                                    id="checkoutPage_add_bank"
                                                                    onClick={() => {
                                                                        toggleFullScreenBankPopup(
                                                                            true,
                                                                            'new',
                                                                            null
                                                                        )
                                                                    }}
                                                                    className="checkoutAddBtn"
                                                                >
                                                                    <span className="material-icons">
                                                                        add
                                                                    </span>
                                                                    Add New Bank
                                                                </Button>
                                                            )}
                                                        </>
                                                    </>
                                                )}
                                                {!changeCard &&
                                                    selectedCard && (
                                                        <>
                                                            {selectedCard.object ===
                                                            'bank_account' ? (
                                                                <>
                                                                    <ListItem
                                                                        button
                                                                        className="CardList"
                                                                    >
                                                                        <div className="savedAddressCard">
                                                                            <div className="cardDetails">
                                                                                <h6>
                                                                                    {
                                                                                        selectedCard.bank_name
                                                                                    }
                                                                                </h6>
                                                                                <h6>
                                                                                    {
                                                                                        selectedCard.last4
                                                                                    }

                                                                                    /
                                                                                    {
                                                                                        selectedCard.routing_number
                                                                                    }
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    </ListItem>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <ListItem
                                                                        button
                                                                        className="CardList"
                                                                    >
                                                                        <div className="savedAddressCard">
                                                                            <div className="cardDetails">
                                                                                <h6>
                                                                                    {
                                                                                        selectedCard.name
                                                                                    }
                                                                                </h6>
                                                                                <h6>
                                                                                    {
                                                                                        selectedCard.brand
                                                                                    }{' '}
                                                                                    ending
                                                                                    in{' '}
                                                                                    {
                                                                                        selectedCard.last4
                                                                                    }
                                                                                </h6>
                                                                                <h6>
                                                                                    EXP:{' '}
                                                                                    {
                                                                                        selectedCard.exp_month
                                                                                    }

                                                                                    /
                                                                                    {
                                                                                        selectedCard.exp_year
                                                                                    }
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    </ListItem>
                                                                    {/* <div className="row">
                                                                    {mapData(cvvForm)}
                                                                </div> */}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                            </div>
                                            {isLoading && <div>Loading...</div>}
                                            <PrimaryButton
                                                disabled={paymentProcessing}
                                                id="credit_submit"
                                                type="submit"
                                                label={'Make Payment'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="PaymentModal">
                        <CardDetails
                            data={manageCard}
                            user={invoiceUser}
                            function={toggleFullScreenCardPopup}
                        />
                    </div>
                </>
            )}
        </FullScreenPopup>
    )
}

export default withRouter(CreditsManage)
